module.exports = __webpack_public_path__ + "img/gift_es.38e680fb.jpg";